document.addEventListener('DOMContentLoaded', function () {
    let data = { age: 12, type: "wake", hr: 0, min: 0, period: "AM", time: 0 };
    var slider = document.getElementById("slider");
    var output = document.getElementById("output");
    output.innerHTML = slider.value + " yrs"

    slider.oninput = function () {
        if (this.value == 65) {
            output.innerHTML = this.value + "+ yrs";
        } else {
            output.innerHTML = this.value + " yrs";
        }
        data.age = this.value;
    }

    let am = true;
    document.querySelector(".type-wake-up").addEventListener("click", function () {
        this.classList.add("active")
        document.querySelector(".type-sleep").classList.remove("active")
        data.type = this.dataset.what;
    })
    document.querySelector(".type-sleep").addEventListener("click", function () {
        this.classList.add("active")
        document.querySelector(".type-wake-up").classList.remove("active")
        data.type = this.dataset.what;
    })
    document.querySelector('[data-period="AM"]').addEventListener("click", function () {
        this.classList.add("active")
        document.querySelector('[data-period="PM"]').classList.remove("active")
        am = true;
        data.period = this.dataset.period;
    })
    document.querySelector('[data-period="PM"]').addEventListener("click", function () {
        this.classList.add("active")
        document.querySelector('[data-period="AM"]').classList.remove("active")
        am = false;
        data.period = this.dataset.period;
    })
    document.querySelector('.hours-value').addEventListener("click", function () {
        document.querySelector(".hours-sheet").classList.toggle("active")
        document.querySelector('.minutes-sheet').classList.remove("active")
    })
    document.querySelector('.minutes-value').addEventListener("click", function () {
        document.querySelector(".minutes-sheet").classList.toggle("active")
        document.querySelector('.hours-sheet').classList.remove("active")
    })
    document.querySelectorAll('span[data-hours]').forEach(function (button) {
        button.addEventListener("click", function () {
            document.querySelector('.hours-value').innerHTML = this.dataset.hours + "h";
            document.querySelector(".hours-sheet").classList.toggle("active")
            data.hr = this.dataset.hours;
        })
    })
    document.querySelectorAll('span[data-minutes]').forEach(function (button) {
        button.addEventListener("click", function () {
            document.querySelector('.minutes-value').innerHTML = this.dataset.minutes + "m";
            document.querySelector(".minutes-sheet").classList.toggle("active")
            data.min = this.dataset.minutes;
        })
    })
    document.querySelector('.sleep-calculator__calculate').addEventListener("click", function () {
        document.querySelector(".sleep-calculator").classList.add("res");
        document.querySelector(".sleep-calculator__results").classList.remove("hidden");
        document.querySelector(".sleep-calculator__logic").classList.add("hidden");
        document.querySelectorAll('.sleep-calculator__item').forEach(function (button) {
            button.classList.remove("optional");
        })
        if (data.type == "wake") {
            if (am) {
                data.time = Number(data.hr) * 60;
            } else if (!am) {
                data.time = Number(data.hr) * 60 + 720;
            }
        } else {
            if (am) {
                data.time = Number(data.hr) * 60;
            } else if (!am) {
                data.time = Number(data.hr) * 60 - 720;
            }
        }
        data.time = Number(data.time) + Number(data.min);
        let res1 = {};
        let res2 = {};
        let res3 = {};
        let res4 = {};
        let a1;
        let a2;
        let a3;
        let a4;
        let t1,
            t2,
            t3,
            t4;
        if (data.type == "wake") {
            let mins;
            let hrs;
            if (data.min == 0) {
                mins = "00 "
            } else {
                mins = data.min;
            }
            if (data.hr == 0) {
                hrs = "00"
            } else {
                hrs = data.hr;
            }
            document.querySelector(".sleep-calculator__result--description").innerHTML = "To wake up at " + hrs + ":" + mins + data.period + ", you should go to bed at:";
            if (data.age == 1) {
                res1.time = 1440 + (Number(data.time) - (8 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) - (9 * 90));
                res3.time = 1440 + (Number(data.time) - (10 * 90));
                res4.time = 1440 + (Number(data.time) - (11 * 90));
                t1 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t2 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                t3 = "<span>15 hrs of sleep,</span> <span>10 sleep cycles</span>";
                t4 = "<span>16.5 hrs of sleep,</span> <span>11 sleep cycles</span>";
            } else if (data.age == 2) {
                res1.time = 1440 + (Number(data.time) - (7 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) - (8 * 90));
                res3.time = 1440 + (Number(data.time) - (9 * 90));
                res4.time = 1440 + (Number(data.time) - (10 * 90));
                t1 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t2 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t3 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                t4 = "<span>15 hrs of sleep,</span> <span>10 sleep cycles</span>";
                res4.optional = true;
            } else if (data.age > 2 && data.age < 6) {
                res1.time = 1440 + (Number(data.time) - (6 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) - (7 * 90));
                res3.time = 1440 + (Number(data.time) - (8 * 90));
                res4.time = 1440 + (Number(data.time) - (9 * 90));
                t1 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t2 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t3 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t4 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
            } else if (data.age >= 6 && data.age < 13) {
                res1.time = 1440 + (Number(data.time) - (6 * 90));
                res2.time = 1440 + (Number(data.time) - (7 * 90));
                res3.time = 1440 + (Number(data.time) - (8 * 90));
                res4.time = 1440 + (Number(data.time) - (9 * 90));
                t1 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t2 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t3 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t4 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                res4.optional = true;
            } else if (data.age >= 13 && data.age < 61) {
                res1.time = 1440 + (Number(data.time) - (5 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) - (6 * 90));
                res3.time = 1440 + (Number(data.time) - (7 * 90));
                res4.time = 1440 + (Number(data.time) - (8 * 90));
                res4.optional = true;
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            } else if (data.age >= 61 && data.age < 65) {
                res1.time = 1440 + (Number(data.time) - (5 * 90));
                res3.optional = true;
                res4.optional = true;
                res2.time = 1440 + (Number(data.time) - (6 * 90));
                res3.time = 1440 + (Number(data.time) - (7 * 90));
                res4.time = 1440 + (Number(data.time) - (8 * 90));
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            } else if (data.age >= 65) {
                res1.time = 1440 + (Number(data.time) - (5 * 90));
                res2.time = 1440 + (Number(data.time) - (6 * 90));
                res3.time = 1440 + (Number(data.time) - (7 * 90));
                res4.time = 1440 + (Number(data.time) - (8 * 90));
                res2.optional = true;
                res3.optional = true;
                res4.optional = true;
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            }
        } else {
            let mins;
            let hrs;
            if (data.min == 0) {
                mins = "00"
            } else {
                mins = data.min;
            }
            if (data.hr == 0) {
                hrs = "00"
            } else {
                hrs = data.hr;
            }
            document.querySelector(".sleep-calculator__result--description").innerHTML = "To go to bed at " + hrs + ":" + mins + data.period + ", you should wake up at:";
            if (data.age == 1) {
                res1.time = 1440 + (Number(data.time) + (8 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) + (9 * 90));
                res3.time = 1440 + (Number(data.time) + (10 * 90));
                res4.time = 1440 + (Number(data.time) + (11 * 90));
                t1 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t2 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                t3 = "<span>15 hrs of sleep,</span> <span>10 sleep cycles</span>";
                t4 = "<span>16.5 hrs of sleep,</span> <span>11 sleep cycles</span>";
            } else if (data.age == 2) {
                res1.time = 1440 + (Number(data.time) + (7 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) + (8 * 90));
                res3.time = 1440 + (Number(data.time) + (9 * 90));
                res4.time = 1440 + (Number(data.time) + (10 * 90));
                t1 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t2 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t3 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                t4 = "<span>15 hrs of sleep,</span> <span>10 sleep cycles</span>";
                res4.optional = true;
            } else if (data.age > 2 && data.age < 6) {
                res1.time = 1440 + (Number(data.time) + (6 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) + (7 * 90));
                res3.time = 1440 + (Number(data.time) + (8 * 90));
                res4.time = 1440 + (Number(data.time) + (9 * 90));
                t1 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t2 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t3 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t4 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
            } else if (data.age >= 6 && data.age < 13) {
                res1.time = 1440 + (Number(data.time) + (6 * 90));
                res2.time = 1440 + (Number(data.time) + (7 * 90));
                res3.time = 1440 + (Number(data.time) + (8 * 90));
                res4.time = 1440 + (Number(data.time) + (9 * 90));
                t1 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t2 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t3 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
                t4 = "<span>13.5 hrs of sleep,</span> <span>9 sleep cycles</span>";
                res4.optional = true;
            } else if (data.age >= 13 && data.age < 61) {
                res1.time = 1440 + (Number(data.time) + (5 * 90));
                res1.optional = true;
                res2.time = 1440 + (Number(data.time) + (6 * 90));
                res3.time = 1440 + (Number(data.time) + (7 * 90));
                res4.time = 1440 + (Number(data.time) + (8 * 90));
                res4.optional = true;
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            } else if (data.age >= 61 && data.age < 65) {
                res1.time = 1440 + (Number(data.time) + (5 * 90));
                res3.optional = true;
                res4.optional = true;
                res2.time = 1440 + (Number(data.time) + (6 * 90));
                res3.time = 1440 + (Number(data.time) + (7 * 90));
                res4.time = 1440 + (Number(data.time) + (8 * 90));
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            } else if (data.age >= 65) {
                res1.time = 1440 + (Number(data.time) + (5 * 90));
                res2.time = 1440 + (Number(data.time) + (6 * 90));
                res3.time = 1440 + (Number(data.time) + (7 * 90));
                res4.time = 1440 + (Number(data.time) + (8 * 90));
                res2.optional = true;
                res3.optional = true;
                res4.optional = true;
                t1 = "<span>7.5 hrs of sleep,</span> <span>5 sleep cycles</span>";
                t2 = "<span>9 hrs of sleep,</span> <span>6 sleep cycles</span>";
                t3 = "<span>10.5 hrs of sleep,</span> <span>7 sleep cycles</span>";
                t4 = "<span>12 hrs of sleep,</span> <span>8 sleep cycles</span>";
            }
        }
        a1 = makeHrs(res1.time);
        a2 = makeHrs(res2.time);
        a3 = makeHrs(res3.time);
        a4 = makeHrs(res4.time);

        if (res1.optional) {
            document.querySelector(".sleep-calculator__item.first").classList.add("optional");
            res1.optional = false;
        }
        if (res2.optional) {
            document.querySelector(".sleep-calculator__item.second").classList.add("optional");
            res2.optional = false;
        }
        if (res3.optional) {
            document.querySelector(".sleep-calculator__item.third").classList.add("optional");
            res3.optional = false;
        }
        if (res4.optional) {
            document.querySelector(".sleep-calculator__item.fourth").classList.add("optional");
            res4.optional = false;
        }
        document.querySelector(".sleep-calculator__item.first .sleep-calculator__block--time").innerHTML = a1;
        document.querySelector(".sleep-calculator__item.second .sleep-calculator__block--time").innerHTML = a2;
        document.querySelector(".sleep-calculator__item.third .sleep-calculator__block--time").innerHTML = a3;
        document.querySelector(".sleep-calculator__item.fourth .sleep-calculator__block--time").innerHTML = a4;

        document.querySelector(".sleep-calculator__item.first .description").innerHTML = t1;
        document.querySelector(".sleep-calculator__item.second .description").innerHTML = t2;
        document.querySelector(".sleep-calculator__item.third .description").innerHTML = t3;
        document.querySelector(".sleep-calculator__item.fourth .description").innerHTML = t4;
    });
    document.querySelector('.sleep-calculator__recalculate').addEventListener("click", function () {
        document.querySelector(".sleep-calculator").classList.remove("res");
        document.querySelector(".sleep-calculator__results").classList.add("hidden");
        document.querySelector(".sleep-calculator__logic").classList.remove("hidden");
    });

    function makeHrs(minutes) {
        if (minutes > 1440) {
            minutes = minutes - 1440;
        }
        let hrs = Math.trunc((minutes / 60))
        let mins = minutes - hrs * 60;
        if (mins == 0) {
            mins = "00"
        } else if (Number(mins) <= 9 && Number(mins) > 0) {
            mins = "0" + mins;
        }
        let per;
        if (minutes > 720 && minutes != 1440) {
            per = "PM"
        } else {
            per = "AM"
        }
        return hrs + ":" + mins;
    }
});